import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import { PARAM_MICROSOFT_CLICK_ID } from './microsoft.constant';

export const useMicrosoftClickId = () => {
  /**
   * "msclkid" is query param added by Microsoft Ads (auto-tagging) from ad links,
   * Microsoft's counterpart of Google's "gclid" (see useGoogleClickId)
   */
  const [msclkid] = useQueryParam('msclkid', withDefault(StringParam, null));
  const [queryClickId] = useQueryParam(PARAM_MICROSOFT_CLICK_ID, withDefault(StringParam, null));
  let microsoftClickId = msclkid || queryClickId;
  if (microsoftClickId) {
    localStorage.setItem(PARAM_MICROSOFT_CLICK_ID, microsoftClickId);
  } else {
    microsoftClickId = localStorage.getItem(PARAM_MICROSOFT_CLICK_ID);
  }
  return { microsoftClickId: microsoftClickId || undefined };
};
